import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/settings2.svg',
})
export class SettingS2Component {}
